import React from "react";
import styled from "styled-components";

const Bar = styled.section`
  margin: 30px 0 0 0;

  h3 {
    border-bottom: 1px solid ${(props) => props.theme.colours.background};
    font-family: "museo-sans-condensed", sans-serif;
    font-size: 1.5rem;
    line-height: 2rem;
    margin: 0 0 20px 0;
    padding: 0 0 20px 0;
  }
`;

export const TweetBar = () => {
  return (
    <Bar>
      <a
        className="twitter-timeline"
        data-chrome="nofooter"
        data-tweet-limit="3"
        href="https://twitter.com/LukeGamble"
      >
        Tweets by LukeGamble
      </a>
    </Bar>
  );
};
